<script setup lang="ts">
import { useToast } from '@/composables/useToast'

const { toasts, remove } = useToast()

const variantConfig = {
  success: { icon: 'check_circle', iconClass: 'text-green-400' },
  error:   { icon: 'error',        iconClass: 'text-red-400' },
  info:    { icon: 'info',         iconClass: 'text-blue-400' },
  warning: { icon: 'warning',      iconClass: 'text-amber-400' },
}

const defaultConfig = variantConfig.info
</script>

<template>
  <Teleport to="body">
    <div
      class="fixed bottom-lg right-lg z-[9999] flex flex-col gap-sm items-end max-w-sm w-full pointer-events-none"
      aria-live="polite"
      aria-label="Notifications"
    >
      <TransitionGroup
        tag="div"
        class="flex flex-col gap-sm items-end w-full"
        enter-active-class="transition-all duration-250 ease-out"
        enter-from-class="opacity-0 translate-x-8"
        enter-to-class="opacity-100 translate-x-0"
        leave-active-class="transition-all duration-200 ease-in"
        leave-from-class="opacity-100 translate-x-0"
        leave-to-class="opacity-0 translate-x-8"
        move-class="transition-all duration-200"
      >
        <div
          v-for="toast in toasts"
          :key="toast.id"
          role="status"
          :aria-label="toast.message"
          class="pointer-events-auto flex items-center gap-sm bg-inverse-surface text-inverse-on-surface rounded-xl shadow-lg px-md py-sm w-full"
        >
          <!-- Variant icon -->
          <span
            class="material-symbols-outlined text-[20px] shrink-0"
            :class="(variantConfig[toast.variant ?? 'info'] ?? defaultConfig).iconClass"
            aria-hidden="true"
          >
            {{ (variantConfig[toast.variant ?? 'info'] ?? defaultConfig).icon }}
          </span>

          <!-- Message -->
          <p class="flex-1 min-w-0 font-body-sm text-body-sm leading-snug">
            {{ toast.message }}
          </p>

          <!-- Dismiss button -->
          <button
            class="shrink-0 p-xs -mr-xs hover:opacity-70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inverse-on-surface rounded transition-opacity"
            aria-label="Dismiss notification"
            @click="remove(toast.id)"
          >
            <span class="material-symbols-outlined text-[18px] text-inverse-on-surface" aria-hidden="true">close</span>
          </button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>
